import { useFeedbackTool } from "./useFeedbackTool";

export const useCanAddMoreFeedbacks = () => {
  const { feedback } = useFeedbackTool();

  return feedback?.some((fb) => fb.isResolved);
};
